import { Link } from 'react-router-dom';
import { useSesion } from '../sesion';

/**
 * Inicio de una persona con sesión abierta.
 *
 * Es deliberadamente flaca: KAN-142 entrega **login, sesión y rutas por rol**.
 * Lo que va adentro llega con las tarjetas siguientes de la épica KAN-140
 * (ABM en KAN-143/144, emisión en KAN-145, listado en KAN-146).
 */
export function Inicio() {
  const { sesion } = useSesion();
  return (
    <main>
      <h1>Hola, {sesion?.nombre}</h1>
      <p>
        Entraste como <strong>{sesion?.email}</strong> con rol <strong>{sesion?.rol}</strong>.
      </p>
      <p>
        <Link to="/emision">Emitir un comprobante</Link>
      </p>
      <p>
        <Link to="/comprobantes">Ver los comprobantes emitidos</Link>
      </p>
      <p>
        <Link to="/contrato">Leer el contrato de la API</Link>
      </p>
      <p>
        <Link to="/tenants">Ver los tenants y sus ids</Link>
      </p>
    </main>
  );
}
